export enum AiEntityType {
    AUDIENCE = 'audience',
    CAMPAIGN = 'campaign',
    TRAIT = 'trait',
    DATA_FIELD = 'data_field',
    JOURNEY = 'journey',
    TEMPLATE = 'template',
    INTELLIGENCE = 'intelligence',
    AGENT_TASK = 'agent_task',
    QUEST = 'quest',
    MEDIA_LIBRARY = 'media_library',
    KPI = 'kpi',
    ANALYTICS_ARTIFACT = 'analytics_artifact',
}

export enum AnalyticsArtifactType {
    CHART = 'chart',
    DASHBOARD = 'dashboard',
}

type AiEntityListBase = {
    id: string;
    name: string;
};

export type AiEntityList =
    | (AiEntityListBase & {
          type: AiEntityType.ANALYTICS_ARTIFACT;
          artifactType: AnalyticsArtifactType;
      })
    | (AiEntityListBase & {
          type: Exclude<AiEntityType, AiEntityType.ANALYTICS_ARTIFACT>;
          artifactType?: null;
      });

export interface AiEntitySearchResults {
    audiences: AiEntityList[];
    campaigns: AiEntityList[];
    customAttributes: AiEntityList[];
    journeys?: AiEntityList[];
    templates?: AiEntityList[];
    quests?: AiEntityList[];
    kpis?: AiEntityList[];
    analyticsArtifacts?: AiEntityList[];
}
